import { ITableFilterState } from './TableFilter.types';

export const onUpdateFilter = (
  key: string,
  value: string,
  state: ITableFilterState,
  setState: (newState: ITableFilterState) => void
) => {
  const tmpFilter = { ...state.filter };
  tmpFilter[key] = value;
  setState({ ...state, filter: tmpFilter });
};

export const onToggle = (
  e: boolean,
  state: ITableFilterState,
  setState: (newState: ITableFilterState) => void
) => {
  if (e) {
    const newFilter = {};
    state.tags.forEach(t => {
      const [key, value] = t;
      newFilter[key] = value;
    });
    setState({ ...state, filter: newFilter });
  }
  setState({ ...state, show: e });
};

export const onSaveClick = (
  onSave: (filter: object) => void,
  state: ITableFilterState,
  setState: (newState: ITableFilterState) => void
) => {
  onSave(state.filter);
  setState({
    ...state,
    tags: Object.entries(state.filter).filter(f => {
      const [_, value] = f;
      return value;
    }),
    filter: {},
    show: false
  });
};

export const onRemoveTag = (
  key: string,
  onSave: (filter: object) => void,
  state: ITableFilterState,
  setState: (newState: ITableFilterState) => void
) => {
  const resultFilter = state.filter;
  resultFilter[key] = '';
  onSave(resultFilter);
  setState({
    ...state,
    tags: state.tags.filter(tag => {
      const [tagKey, _] = tag;
      return tagKey !== key;
    })
  });
};
